// TitleWithDot.jsx
import React from "react";

export default function Title({
  children,
  size = "24px",
  className = "",
  color = "title-color",
  showDot = false,
  dotColor = "bg-orange-500",
  as = "h2", // ✅ new prop: h1 | h2 | h3
}) {
  const Tag = as;

  return (
    <div className="flex items-center gap-2">
      <Tag
        className={`font-extrabold leading-[26px] ${color} ${className}`}
        style={{ fontSize: size }}
      >
        {children}
      </Tag>

      {showDot && (
        <span className="relative flex w-2 h-2">
          <span
            className={`absolute inline-flex h-full w-full animate-ping rounded-full ${dotColor} opacity-75`}
          />
          <span
            className={`absolute inline-flex h-full w-full animate-ping rounded-full ${dotColor} opacity-50`}
          />
          <span
            className={`absolute inline-flex h-full w-full animate-ping rounded-full ${dotColor} opacity-25`}
          />
          <span
            className={`relative inline-flex w-2 h-2 rounded-full ${dotColor}`}
          />
        </span>
      )}
    </div>
  );
}
